import React from 'react';

function Controls({ yearFilter, showFilter, onYearFilterChange, onShowFilterChange, onScrollToCurrent }) {
  return (
    <div className="controls">
      <label htmlFor="year-filter">Filter by Year:</label>
      <select 
        id="year-filter" 
        value={yearFilter} 
        onChange={(e) => onYearFilterChange(e.target.value)}
      >
        <option value="all">All Years</option>
        <option value="2025">2025</option>
        <option value="2026">2026</option>
        <option value="2027">2027</option>
        <option value="2028">2028</option>
        <option value="2029">2029</option>
      </select>
      
      <label htmlFor="show-rows">Show:</label>
      <select 
        id="show-rows" 
        value={showFilter} 
        onChange={(e) => onShowFilterChange(e.target.value)}
      >
        <option value="all">All Weeks</option>
        <option value="monthly">Monthly Only</option>
      </select>
      
      <button onClick={onScrollToCurrent} className="scroll-button">
        📅 Go to Current Week
      </button>
    </div>
  );
}

export default Controls;
